export default __webpack_public_path__ + "static/media/mocha.ea4c9b58.png";